import { render, staticRenderFns } from "./OrbitStrategyCreateModal.vue?vue&type=template&id=31cd238e&scoped=true"
import script from "./OrbitStrategyCreateModal.vue?vue&type=script&lang=js"
export * from "./OrbitStrategyCreateModal.vue?vue&type=script&lang=js"
import style0 from "./OrbitStrategyCreateModal.vue?vue&type=style&index=0&id=31cd238e&prod&scoped=true&lang=css"
import style1 from "./OrbitStrategyCreateModal.vue?vue&type=style&index=1&id=31cd238e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd238e",
  null
  
)

export default component.exports